import React from "react";
import { Container, Row, Col } from "react-bootstrap";

// Import components
import Particle from "./Particle";
import Type from "./Home/Type";
import Aboutcard from "./About/AboutCard";
import Work from "./Work/Work";
import Skills from "./Skills/Skills";
import Contact from "./Contact/Contact";

// Import assets
import selfie from "../Assets/selfie.jpg";

function SinglePage() {

  return (
    <div>
      <Particle />
      
      {/* Home Section */}
      <section id="home" className="home-section">
        <Container className="home-content">
          <Row className="align-items-center justify-content-center text-center">
            <Col lg={10} xl={8}>
              <div className="animate-fade-in-up">
                <Row className="align-items-center">
                  <Col lg={7} className="mb-4 mb-lg-0">
                    <h1 className="heading-name mb-3">
                      <strong className="main-name">BENJAMIN SZABO</strong>
                    </h1>
                    
                    <div style={{ height: "120px", display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden" }}>
                      <Type />
                    </div>
                  </Col>

                  <Col lg={5} className="d-flex justify-content-center">
                    <div className="animate-fade-in-up" style={{ 
                      animationDelay: "0.3s",
                      position: "relative",
                      zIndex: 30
                    }}>
                      <div style={{
                        backgroundColor: "#0a0a0a",
                        borderRadius: "50%",
                        padding: "2px",
                        display: "inline-block"
                      }}>
                        <img
                          src={selfie}
                          alt="Benjamin Szabo"
                          className="img-fluid selfie-image"
                          style={{ 
                            maxHeight: "320px",
                            objectFit: "cover",
                            aspectRatio: "1/1",
                            display: "block",
                            opacity: "1",
                            backgroundColor: "#0a0a0a"
                          }}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* About Section */}
      <section id="about" className="about-section">
        <Container>
          <Row className="justify-content-center mb-5">
            <Col lg={8} className="animate-fade-in-up">
              <h1 className="project-heading text-center">
                Know More About <strong className="text-gradient">Me</strong>
              </h1>
              <Aboutcard />
            </Col>
          </Row>
        </Container>
      </section>

      {/* Work Section - Experience + Projects */}
      <Work />

      {/* Skills Section */}
      <Skills />

      {/* Contact Section */}
      <Contact />
    </div>
  );
}

export default SinglePage;